<template>
    <div class="loading-cell">
        <a-skeleton active :paragraph="{ rows: 1 }" :title="false" />
    </div>
</template>

<script>
export default {
    name: "LoadingCell",
    components: {},
    props: {
        fieldType: {
            type: String,
        },
    },
};
</script>

<style scoped>
.loading-cell {
    width: 100%;
    height: 100%;
    .ant-skeleton {
        width: 100%;
        height: 100%;
        .ant-skeleton-paragraph {
            margin: 0px !important;
            width: 100%;
            height: 100%;
            li {
                width: 100% !important;
                height: 100% !important;
            }
        }
        
    }
}
</style>
